/** Central content for Poonji Mitra digital financial platform */

export const STATS = [
  { value: 1500, suffix: "+", label: "Clients Served" },
  { value: 40, prefix: "₹", suffix: " Cr+", label: "Assets Under Management" },
  { value: 200, prefix: "₹", suffix: " Cr+", label: "Debt Finance Raised" },
  { value: 500, suffix: "+", label: "Companies Incorporated" },
  { value: 40, suffix: "+", label: "Years Combined Experience" },
  { value: 500, suffix: "+", label: "Students Mentored" },
];

export const TEAM = [
  {
    id: "nikhil",
    name: "Nikhil Gupta, CFA",
    designation: "Founder",
    qualification: "CFA Charterholder",
    expertise:
      "Investment, algo trading & portfolio management. Chairman — Sawai Madhopur Urban Cooperative Bank.",
    linkedin: "https://www.linkedin.com/in/nikhil-gupta-cfa-finance",
    initials: "NG",
  },
  {
    id: "rakesh",
    name: "CA Rakesh Gupta",
    designation: "Advisor",
    qualification: "Chartered Accountant",
    expertise:
      "Fund raising via debt & equity. 35+ years of experience in project finance.",
    linkedin: null,
    initials: "RG",
  },
  {
    id: "vijay",
    name: "CA Vijay Gupta",
    designation: "Advisor",
    qualification: "Chartered Accountant",
    expertise:
      "Tax & company audit, accounting and tax planning for businesses of all sizes.",
    linkedin: null,
    initials: "VG",
  },
  {
    id: "ruchika",
    name: "CS Ruchika Gupta",
    designation: "Advisor",
    qualification: "Company Secretary",
    expertise:
      "Company incorporation, compliances and legal related matters.",
    linkedin: null,
    initials: "RuG",
  },
  {
    id: "deepak",
    name: "Deepak Singh",
    designation: "Adviser",
    qualification: "Client Advisory",
    expertise:
      "Client advisory & investment solutions across the Poonji ecosystem.",
    linkedin: null,
    initials: "DS",
  },
];

export const SERVICES = [
  {
    slug: "portfolio-management",
    title: "Portfolio Management",
    icon: "Briefcase",
    desc: "Custom equity and multi-asset portfolios aligned to your goals, risk profile, and time horizon.",
    href: "/services#portfolio-management",
  },
  {
    slug: "mutual-funds",
    title: "Mutual Fund Wealth Management",
    icon: "PieChart",
    desc: "Goal-based SIPs, fund selection, rebalancing, and continuous portfolio review.",
    href: "/mutual-funds",
  },
  {
    slug: "algo-trading",
    title: "Algo Trading",
    icon: "Cpu",
    desc: "Rules-based strategies for investors and white-label solutions for brokers.",
    href: "/algo-trading",
  },
  {
    slug: "unlisted-shares",
    title: "Unlisted Shares",
    icon: "Gem",
    desc: "Research-backed pre-IPO and unlisted opportunities with documentation support.",
    href: "/unlisted-shares",
  },
  {
    slug: "ipo-advisory",
    title: "IPO Advisory",
    icon: "Rocket",
    desc: "Upcoming IPO analysis, GMP tracking, financial review, and listing insights.",
    href: "/ipo-advisory",
  },
  {
    slug: "bonds",
    title: "Bonds",
    icon: "Landmark",
    desc: "Government, corporate, tax-free bonds and SGBs with clear YTM and risk guidance.",
    href: "/bonds",
  },
  {
    slug: "accounting",
    title: "Accounting & Auditing",
    icon: "Calculator",
    desc: "Books, statutory audits, and clean financials for startups and established firms.",
    href: "/business-services#accounting",
  },
  {
    slug: "tax-planning",
    title: "Tax Planning",
    icon: "Receipt",
    desc: "Smart tax structures for individuals and businesses across income and investments.",
    href: "/business-services#tax",
  },
  {
    slug: "debt-funding",
    title: "Debt Funding",
    icon: "Banknote",
    desc: "Business loans, NBFC partnerships, and structured debt to fuel growth.",
    href: "/business-services#debt",
  },
  {
    slug: "equity-funding",
    title: "Equity Funding",
    icon: "TrendingUp",
    desc: "Pitch readiness, investor connects, and capital raising support for ambitious founders.",
    href: "/business-services#equity",
  },
  {
    slug: "company-formation",
    title: "Company & LLP Formation",
    icon: "Building2",
    desc: "End-to-end incorporation, registrations, and compliance for new entities.",
    href: "/business-services#formation",
  },
  {
    slug: "govt-schemes",
    title: "Government Schemes & Subsidies",
    icon: "BadgeCheck",
    desc: "Identify and unlock eligible subsidies, MSME schemes, and incentive programs.",
    href: "/business-services#schemes",
  },
  {
    slug: "insurance",
    title: "Insurance",
    icon: "Shield",
    desc: "Health, life, and business cover with policy comparison and claim assistance.",
    href: "/insurance",
  },
  {
    slug: "education",
    title: "Financial Education",
    icon: "GraduationCap",
    desc: "Practical learning via Poonji Vidhya — markets, investing, and career pathways.",
    href: "/learning-centre",
  },
  {
    slug: "cooperative",
    title: "Cooperative Banking",
    icon: "Users",
    desc: "Advisory for cooperative banking products and community-focused finance.",
    href: "/business-services#cooperative",
  },
  {
    slug: "nbfc",
    title: "NBFC Services",
    icon: "Building",
    desc: "NBFC structuring, product design support, and regulatory-aware growth pathways.",
    href: "/business-services#nbfc",
  },
];

export const STRATEGIES = [
  {
    title: "Goal-Based Investing",
    desc: "Map every rupee to a life goal — education, retirement, home, or business expansion.",
    icon: "Target",
  },
  {
    title: "Long-Term Wealth Creation",
    desc: "Compounding-first approach with disciplined SIPs and quality equity exposure.",
    icon: "Mountain",
  },
  {
    title: "Mutual Fund Strategy",
    desc: "Category allocation, fund shortlisting, and periodic review against benchmarks.",
    icon: "Layers",
  },
  {
    title: "Equity Portfolio Strategy",
    desc: "Fundamentals-driven stock selection with position sizing and exit discipline.",
    icon: "LineChart",
  },
  {
    title: "Algo Trading Strategy",
    desc: "Backtested, rules-based execution to remove emotion from market timing.",
    icon: "Bot",
  },
  {
    title: "Risk Management Framework",
    desc: "Drawdown limits, diversification rules, and risk scores for every portfolio.",
    icon: "ShieldAlert",
  },
  {
    title: "Quarterly Portfolio Review",
    desc: "Structured reviews to rebalance, tax-harvest, and realign with goals.",
    icon: "CalendarCheck",
  },
  {
    title: "Diversification Strategy",
    desc: "Balance across asset classes, sectors, and geographies to smooth volatility.",
    icon: "Shuffle",
  },
];

export const QUICK_ACCESS = [
  { title: "Review My Portfolio", href: "/portfolio-review", icon: "FileSearch", accent: "#2da88c" },
  { title: "Start SIP", href: "/calculators#sip", icon: "Repeat", accent: "#3ecfad" },
  { title: "Mutual Funds", href: "/mutual-funds", icon: "PieChart", accent: "#3bb89a" },
  { title: "Bonds", href: "/bonds", icon: "Landmark", accent: "#4db89e" },
  { title: "Unlisted Shares", href: "/unlisted-shares", icon: "Gem", accent: "#6b8f3d" },
  { title: "IPO Advisory", href: "/ipo-advisory", icon: "Rocket", accent: "#b0893c" },
  { title: "Algo Trading", href: "/algo-trading", icon: "Cpu", accent: "#3b7ea6" },
  { title: "Business Finance", href: "/business-services", icon: "BriefcaseBusiness", accent: "#6b5b95" },
  { title: "Insurance", href: "/insurance", icon: "Shield", accent: "#a85d7a" },
];

export const AUDIENCES = [
  "Individuals",
  "Investors",
  "Startups",
  "SMEs",
  "Businesses",
];

export const ABOUT = {
  story:
    "Poonji Mitra was built to end fragmented financial decision-making. From Jaipur, we bring portfolio management, wealth products, business finance, tax, and compliance into one trusted ecosystem — so families and founders can grow with clarity.",
  mission:
    "To democratize professional-grade financial guidance and make India's complete financial toolkit accessible under one roof.",
  vision:
    "To be India's most trusted digital financial platform — where every individual and business finds lasting partners, not just products.",
  why: [
    "One ecosystem spanning investments, business finance, tax, and insurance",
    "CFA and CA/CS-led advisory with research-driven processes",
    "Transparent recommendations aligned to your goals — not product push",
    "Long-term relationship model with quarterly reviews and education",
  ],
  philosophy:
    "We invest with discipline: goals first, risk second, products third. Diversification, patience, and continuous review beat speculation.",
  endToEnd:
    "From company registration and funding to mutual funds, bonds, unlisted shares, algo strategies, and insurance — Poonji Mitra walks with you across the full financial lifecycle.",
};

export const VIDEOS = [
  {
    id: "v1",
    title: "How Mutual Funds Work — Beginner Guide",
    youtubeId: "o2lbyzHhHII",
    thumbnail: "https://img.youtube.com/vi/o2lbyzHhHII/hqdefault.jpg",
  },
  {
    id: "v2",
    title: "SIP Investing Explained Simply",
    youtubeId: "ZYhXF3nYr3I",
    thumbnail: "https://img.youtube.com/vi/ZYhXF3nYr3I/hqdefault.jpg",
  },
  {
    id: "v3",
    title: "Asset Allocation & Diversification Basics",
    youtubeId: "fFTXJF4iQbM",
    thumbnail: "https://img.youtube.com/vi/fFTXJF4iQbM/hqdefault.jpg",
  },
];

export const TRUST_ITEMS = [
  { title: "AMFI / ARN Registered", desc: "Mutual fund distribution via registered ARN (Kanchan Gupta – ARN 175447).", icon: "Award" },
  { title: "Professional Team", desc: "CFA, CA, and CS advisors guiding investment and business decisions.", icon: "UsersRound" },
  { title: "Company Registration", desc: "Compliant entity with transparent processes and documentation.", icon: "FileBadge" },
  { title: "Research-Driven", desc: "Fund, equity, IPO, and bond selection backed by structured research.", icon: "Microscope" },
  { title: "Client Statistics", desc: "1500+ clients, ₹40 Cr+ AUM, ₹200 Cr+ debt raised, 500+ companies formed.", icon: "BarChart3" },
  { title: "Compliance Standards", desc: "SEBI/AMFI-aware practices with clear risk disclosures on every product.", icon: "Scale" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "All Services", to: "/services" },
      { label: "Business Solutions", to: "/business-services" },
      { label: "Insurance", to: "/insurance" },
    ],
  },
  {
    label: "Products",
    to: "/mutual-funds",
    children: [
      { label: "Mutual Funds", to: "/mutual-funds" },
      { label: "Bonds", to: "/bonds" },
      { label: "Unlisted Shares", to: "/unlisted-shares" },
      { label: "IPO Advisory", to: "/ipo-advisory" },
      { label: "Algo Trading", to: "/algo-trading" },
    ],
  },
  { label: "Portfolio Review", to: "/portfolio-review" },
  { label: "Strategies", to: "/strategies" },
  {
    label: "More",
    children: [
      { label: "Calculators", to: "/calculators" },
      { label: "Learning Centre", to: "/learning-centre" },
      { label: "Team", to: "/team" },
      { label: "Blogs", to: "/blogs" },
    ],
  },
  { label: "Contact", to: "/contact" },
];
